import clsx from "clsx";
import { FC, ReactNode } from "react";

export const BanxaReviewRow: FC<{
  label: string;
  value: ReactNode;
  emphasized?: boolean;
  mono?: boolean;
}> = ({ label, value, emphasized, mono }) => (
  <div className="banxa-ramp__review-row">
    <span>{label}</span>
    <strong
      className={clsx({
        "banxa-ramp__review-value--emphasized": emphasized,
        "banxa-ramp__review-value--mono": mono,
      })}
      title={mono && typeof value === "string" ? value : undefined}>
      {value}
    </strong>
  </div>
);
